import React, { useEffect } from 'react';
import classNames from 'classnames/bind';
import { Heading } from '@thd-olt-component-react/heading';
import styles from './shop-by-category.scss';
import data from '../../docs/assets/shop-by-category.json';

const cx = classNames.bind(styles);
const ShopByCategory = () => {
  const title = 'Shop By Category';
  const categoryList = data.CategoryData;

  useEffect(() => {
    LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('shop-by-category.ready');
  }, []);

  const buildCategoryGrid = () => {
    return (
      (categoryList || []).map((category) => (
        <div key={category.title.replace(/\s/, '_')} className="col__6-12 col__2-12--sm">
          <a
            className={cx('shop-by-category__category-link')}
            href={category.link}
            title={category.title}
          >
            <div className={cx('shop-by-category__category-wrapper')}>
              <span className={cx('shop-by-category__category-icon-wrapper')}>
                <img
                  src={category.imageURL}
                  className={`stretchy_ ${cx('shop-by-category__category-img')}`}
                  alt={category.title}
                  title={category.title}
                  loading="lazy"
                  height=""
                  width=""
                />
              </span>
            </div>
            <div className={cx('shop-by-category__category-title')}>
              <div className={cx('shop-by-category__category-text')}>
                {category.title}
              </div>
            </div>
          </a>
        </div>
      ))
    );
  };

  return (
    <div className={cx('shop-by-category')}>
      <div className={`grid ${cx('shop-by-category')}`}>
        <div className="col__12-12">
          <Heading underline title={title} className="shop-by-category--title" />
          <div className={cx('shop-by-category__content')}>
            {buildCategoryGrid()}
          </div>
        </div>
      </div>
    </div>
  );
};
ShopByCategory.dataModel = {};
ShopByCategory.displayName = 'ShopByCategory';
export { ShopByCategory };
